import Lozenge from '@atlaskit/lozenge';
import { IAlertDao } from 'core/api/types/alerts.interface';

export const alertTemplates = [
  {
    template: (alert: IAlertDao) => <p>{alert.triggered.by.fullName || '-'}</p>,
    id: 'triggeredBy',
  },
  {
    template: (alert: IAlertDao) => <p>{alert.triggered.at.toDate().toLocaleString() || '-'}</p>,
    id: 'triggeredAt',
  },
  {
    template: (alert: IAlertDao) => <p>{alert.acknowledged?.by.fullName || '-'}</p>,
    id: 'acknowledgedBy',
  },
  {
    template: (alert: IAlertDao) => <p>{alert.acknowledged?.at.toDate().toLocaleString() || '-'}</p>,
    id: 'acknowledgedAt',
  },
  {
    template: (alert: IAlertDao) => (
      <Lozenge appearance={alert.acknowledged ? 'success' : 'removed'}>
        {alert.acknowledged ? 'Acknowledged' : 'Not acknowledged'}
      </Lozenge>
    ),
    id: 'acknowledged',
  },
];
